import { render, staticRenderFns } from "./ListPlan.vue?vue&type=template&id=4a20a8ef&"
import script from "./ListPlan.vue?vue&type=script&lang=js&"
export * from "./ListPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports